export default "__VITE_ASSET__C0MEGv$B__";